module.exports = __webpack_public_path__ + "img/jamaica.dbbef169.png";